/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <div class="callpolicepage" ref="callpolicepage" :style="{ height: pageH + 'px' }">
        <!-- 内容区域 -->
        <Row :gutter="20">
          <i-col span="6">
            <div class="leftbox">
              <div class="linehr"></div>
              <Spin v-if="treeLoading" fix>
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                <div>菜单加载中...</div>
              </Spin>
              <Input style="width: 200px" v-model="seachCName" class="tabdiv" placeholder="搜索企业">
                <span slot="append" @click="getTreeInfo"><Icon type="ios-search-outline" /></span>
              </Input>

              <div style="overflow: hidden">
                <el-tree
                  ref="treeBox"
                  node-key="keyID"
                  :data="treeData"
                  :default-expanded-keys="expandedKeys"
                  :props="defaultProps"
                  :highlight-current="true"
                  :render-content="renderContent"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
          </i-col>
          <i-col span="18" class="rightBigBox">
            <div class="rightBox">
              <div class="topLine">
                <div>
                  <template>
                    <Select v-model="callId" style="width: 200px">
                      <Option v-for="item in callType" :value="item.id" :key="item.id">{{ item.label }}</Option>
                    </Select>
                  </template>
                </div>
                <div>
                  <template>
                    <Select v-model="detectionId" style="width: 200px">
                      <Option v-for="item in detectionList" :value="item.codeId" :key="item.codeId">{{
                        item.cnName
                      }}</Option>
                    </Select>
                  </template>
                </div>
                <div>
                  <span class="timeText">报警时间</span>
                  <DatePicker
                    v-model="timeRange"
                    type="datetimerange"
                    placeholder="请选择时间"
                    format="yyyy-MM-dd"
                    style="width: 300px"
                  ></DatePicker>
                </div>
                <div><Button @click="getYYHistoryInfo">查询</Button></div>
                <div>
                  <Button type="primary" ghost @click="exportData"><i class="iconfont icon-daochu"></i>导出</Button>
                </div>
              </div>
              <template>
                <Table :columns="columns2" :data="data1"></Table>
              </template>
            </div>

            <Page
              style="margin-top: 0.625rem; margin-bottom: 0.625rem"
              show-total
              :current.sync="page"
              :page-size-opts="[20, 50, 100, 200, 500]"
              :page-size="row"
              :total="total"
              show-sizer
              @on-change="onNextPage"
              @on-page-size-change="onPageSize"
            />
          </i-col>
        </Row>
      </div>
    </X-Layout>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import { createTree, customContent, createTitle, downfile } from '@/common/common.js';
import { mathEleHeight } from '@/utils/common';
export default {
  data() {
    return {
      pageH: '',
      timeRange: [], // 时间段
      detectionList: [], //检测项列表
      detectionId: null, // 检测项的id
      // 报警默认值
      callId: 3,
      // 报警类型
      callType: [
        {
          id: 3,
          label: '全部',
        },
        {
          id: 2,
          label: '超出标准',
        },
        {
          id: 1,
          label: '低于标准',
        },
      ],
      btnFlag: '1', // 默认被选中的按钮
      checkId: '',
      activeFlag: 'name1', //被选中的选项
      dataList: [], // 实时
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'childrens',
        label: 'title',
      },
      expandedKeys: [], // 指定树菜单展开key
      treeData: [], // 树菜单数据
      treeLoading: false, // 树菜单加载动画
      dataInfoLoading: false, // 信息加载动画
      comids: '', // 接收传进来的公司ID
      gkSite_id: '', // 排口id
      seachCName: '', // 搜索企业名
      tbLoading: false, // 数据表的加载动画开关
      total: 0, // 总数
      page: 1, // 当前第一页
      row: 20, // 每页多少数据
      columns2: [], // 表头
      data1: [], // 表数据
    };
  },

  mounted() {
    this.comids = this.$route.params.id ? this.$route.params.id : null; // 有传入公司ID
    this.getTreeInfo(); // 执行初始化树菜单
    this.initTableTitle(); // 初始化表头
    this.pageH = mathEleHeight(this.$refs.callpolicepage, 20);
    console.log(h);
  },

  methods: {
    // 初始化表头
    initTableTitle() {
      this.columns2 = createTitle(this.page, this.row);
    },
    // 按钮被选中事件
    checkBtn(num) {
      this.btnFlag = num;
    },
    /**
     * 树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContent: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 街道显示数量 报警变色
          return customContent(data, node, h);

        case 2: // 第2层 公司需要显示数量 报警变色
          return customContent(data, node, h);

        case 3: // 第3层 排口不需要显示数量 报警变色
          return customContent(data, node, h);
      }
    },
    /**
     * 渲染树菜单 根据树菜单要求处理传入得到list数据
     * 获取第一层
     */
    handleTreeList(list) {
      // 遍历树形菜单 后台数据
      let res = createTree(list);
      this.treeData = res.list; // 整理好的树形列表
      this.expandedKeys = res.keyGkId; // 被展开的key
      this.getDetection(res.selGkId);
      this.$nextTick(() => {
        // 设置选中高亮
        this.$refs.treeBox.setCurrentKey(res.keyGkId[1]);
      });
    },
    /**
     * 初始化树菜单数据
     */
    getTreeInfo() {
      const api = this.ApiUrl + 'ycData/findAllYc';
      const data = {
        param: this.seachCName,
      };
      this.treeLoading = true; // 开启加载动画
      this.dataInfoLoading = true; // 把信息页加载动画也开启
      // 请求接口
      this.$http.post(api, data, { emulateJSON: 'application/x-www-form-urlencoded' }).then(
        res => {
          if (res.data.extend.news === 0) {
            this.handleTreeList(res.data.extend.pageInfo); // 1.渲染树菜单
          }
          this.treeLoading = false; // 开启加载动画
        },
        res => {
          this.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 树菜单单击事件
     */
    handleNodeClick(data) {
      if (data.gkSite_id == this.checkId) {
        return;
      }
      this.checkId = data.gkSite_id;
      // 如果是第3层 就触发 表格事件
      if (data.level === 3) {
        this.yyTableList = []; // 清空数据表
        this.dataList = []; // 清空实时数据

        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.page = 1; // 初始化 设置第一页
        this.total = 0; // 初始化总条数
      }
    },
    // 数据导出

    exportData() {
      // 检测项
      if (!this.detectionId) {
        this.$Message.warning('请选择检测项');
        return;
      }

      if (!this.timeRange[0]) {
        this.$Message.warning('请选择时间段');
        return;
      }

      const apis = 'exportExcel/ycWarnData';
      // type:1低于2高于3全部
      this.data = {
        type: this.callId, // 报警类型
        codeId: this.detectionId, // 检测项id
        startTime: new Date(this.timeRange[0]).getTime(), // 开始时间
        endTime: new Date(this.timeRange[1]).getTime(), // 结束时间
      };

      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news == 0) {
            if (res.data.extend.src) {
              let url = res.data.extend.src;
              /**下载excl文件
               * 	param : {res.data.extend.src} 链接
               * 	param :{url.substring(url.lastIndexOf('/')+1,url.lenght)}  文件名
               */
              downfile(res.data.extend.src, url.substring(url.lastIndexOf('/') + 1, url.lenght));
            }
          }
        },
        res => {},
      );
    },
    // 通过排口id获取检测项
    getDetection(gkid) {
      const apis = 'ycData/getYcCodeByCompanyId';
      this.data = {
        gkSiteId: gkid,
      };
      this.tbLoading = true; // 开启加载动画

      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news == 0) {
            if (res.data.extend.codeList) {
              this.detectionList = res.data.extend.codeList;
            }
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },

    /**
     * 得到报警信息
     */
    getYYHistoryInfo() {
      let startTime = '';
      let endTime = '';
      // 时间判断
      if (this.timeRange[0] && this.timeRange[1]) {
        startTime = new Date(this.timeRange[0]).getTime();
        endTime = new Date(this.timeRange[1]).getTime();
      } else {
        this.$Message.warning('请选择时间');
        return;
      }

      if (!this.detectionId) {
        this.$Message.warning('请选择检测项');
        return;
      }

      const apis = 'ycData/getYcWarnData';
      this.data = {
        pageNum: this.page,
        pageSize: this.row,
        type: this.callId, // 报警类型
        codeId: this.detectionId, // 检测项
        startTime: startTime, // 开始时间
        endTime: endTime, // 结束时间
      };
      this.data1 = []; // 初始化数据
      this.tbLoading = true; // 开启加载动画
      // 开启请求
      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news === 0) {
            let list = res.data.extend.dataList;
            // 将表中数据重排
            for (let i = 0; i < list.length; i++) {
              list[i] = {
                data: list[i],
              };
            }
            this.data1 = list; // 获取数据

            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.total = 0;
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },
    // 被选中项的事件(实时 name1 历史 name2)
    checkedTab() {
      if (this.activeFlag == 'name1' && this.dataList.length <= 0) {
      } else if (this.activeFlag == 'name2' && this.yyTableList.length <= 0) {
        this.getYYHistoryInfo();
      }
    },

    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.initTableTitle(); // 重新初始化表头
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 切换下一页
    onNextPage(e) {
      this.page = e;
      this.initTableTitle(); // 重新初始化表头
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.callpolicepage {
  .leftbox {
    background: #fff;
    overflow: hidden;
    position: relative;
    padding: 20px 15px;

    .linehr {
      height: 5px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #0062ff;
    }
  }
  .company_text {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    position: relative;
    padding-left: 14px;
    margin-bottom: 15px;
  }
  .company_text::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background: #0062ff;
    width: 4px;
    height: 14px;
  }
}
.ivu-table {
  font-size: 14px;
}

.topbtn {
  display: flex;
}

.topbtn > div {
  margin-right: 20px;
}

.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.timebox {
  margin-top: 2px;
}

.changbox > button {
  border-radius: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.yyNow {
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  text-align: center;
}

.yyNow i {
  font-size: 36px;
}

.yyNow .ctime {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
}

.yyDiv {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

.yyDiv .yyz {
  width: 100%;
  min-width: 900px;
  flex-shrink: 0;
}

.imgbox {
  padding-top: 2.5rem;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.imgbox img {
  width: 6.25rem;
  height: 6.25rem;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}

.boxStatus {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
  line-height: 26px;
}

.normal {
  background-color: #19be6b;
}

.exceed {
  background-color: #ed4014;
}

.btnList {
  position: absolute;
  top: 0;
  right: 10px;
  height: 37px;
  display: flex;
  flex-wrap: nowrap;
  letter-spacing: 2px;
}

.btnList > div {
  margin-left: 5px;
}

.rightBox {
  position: relative;
  min-width: 1000px;
}

.topLine {
  display: flex;
  margin-bottom: 40px;
  align-items: center;
  flex-wrap: wrap;
}

.topLine > div {
  margin-right: 10px;
}

.timeText {
  margin-right: 10px;
}

.rightBigBox {
  background-color: #fff;
  padding-top: 10px;
}

.rightBox {
  position: relative;
  min-width: 1000px;
}
</style>
